import $ from 'jquery';
import locations from '../config/locations';
import md5 from 'md5';
import { optInList, optOutList } from './optLists';

let utils = {
    callApi(submitData, targetUri, successCallback, errorCallback, method) {
        method = method || 'POST';
        $.ajax({
            url: locations.apiv3 + targetUri,
            type: method,
            data: JSON.stringify(submitData),
            contentType: 'application/json',
            success: successCallback,
            error: errorCallback
        });
    },

    recordUser(email) {
        $.ajax({
            url: '/trackusage/' + email,
            type: 'GET',
        });
    },

    canUpgrade(orgId, successCallback) {
        $.ajax({
            url: '/freetrial/upgradable/' + orgId,
            type: 'GET',
            success: successCallback
        });
    },

    sendEmail(emailAddress, successCallback, errorCallback) {
        utils.callApi(
            { testing_uri: window.location.pathname },
            'freetrial/' + md5(emailAddress) + '/validationemail',
            successCallback,
            errorCallback
        );
    },

    getCountries(successCallback, errorCallback) {
        $.ajax({
            url: '/countries',
            type: 'GET',
            success: successCallback
        });
    },

    validateForm(fields) {
        let errors = [];

        for (let key in fields) {
            let info = fields[key],
                selector = '#' + key,
                $element = $(selector),
                required = info.required instanceof Function ? info.required() : info.required;

            if ($('body').attr('id') === 'ie9') {
                if ($element.val() === $element.attr('placeholder')) {
                    $element.val('');
                }
            }

            let val = $element.val() ? $element.val() : '';

            if (required && !val.length) {
                errors.push({
                    val: val,
                    name: info.name,
                    selector: selector,
                    displaySelector: info.displaySelector,
                    str: info.name + ' is a required field'
                });
            } else if (required && info.maxLength && val.length > info.maxLength) {
                errors.push({
                    val:val,
                    name: info.name,
                    selector: selector,
                    displaySelector: info.displaySelector,
                    str: info.name + ' cannot be longer than ' + info.maxLength + 'characters'
                });
            } else if (required && info.regex) {
                if (!~val.search(info.regex)) {
                    errors.push({
                        val: val,
                        name: info.name,
                        selector: selector,
                        displaySelector: info.displaySelector,
                        str: info.name + ' is invalid'
                    });
                }
            } else if (required && info.minValue && parseInt(val, 10) < info.minValue) {
                errors.push({
                    val: val,
                    name: info.name,
                    selector: selector,
                    str: info.name + " can't be under " + info.minValue
                });
            }
        }

        if ($('body').attr('id') === 'ie9') {
            for (let key in fields) {
                let selector = '#' + key,
                    $element = $(selector);

                if ($element.val() === '') {
                    $element.val($element.attr('placeholder'));
                }
            }
        }

        return errors;
    },

    clearErrors() {
        $('.errorPointer').remove();
        $('.error').removeClass('error');
    },

    displayErrors(errors) {
        this.clearErrors();

        errors.forEach((error, i) => {
            var selector = typeof error.displaySelector !== 'undefined' ? error.displaySelector : error.selector;
            $(selector).addClass('error').after(
                $('<div/>').addClass('errorPointer').html(error.str)
            );
        });
    },

    checkOptIn(country) {
        if (~optInList.indexOf(country)) {
            return true;
        }
        return false;
    },

    checkOptOut(country) {
        if (~optOutList.indexOf(country)) {
            return true;
        }
        return false;
    }
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils.js